export const lastSeenBodyTemplate = (rowData,textOnly) => {
    if (rowData.isGroupHeader) return null
    
    const lastSeen = new Date(rowData.lastSeenAt)
    console.log('lastSeen', lastSeen ,rowData)
    const now = new Date()
    const diffMs = now.getTime() - lastSeen.getTime()
    const diffMinutes = Math.floor(diffMs / (1000 * 60))
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60))
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24))
    const diffMonths = Math.floor(diffDays / 30)
    const restDays = diffDays % 30

    let timeText = ''
    let colorClass = ''

    if (diffMinutes < 5) {
      timeText = "À l'instant"
      colorClass = 'text-green-600'
    } else if (diffMinutes < 60) {
      timeText = `Il y a ${diffMinutes} min`
      colorClass = diffMinutes < 30 ? 'text-blue-600' : 'text-orange-500'
    } else if (diffHours < 24) {
      timeText = `Il y a ${diffHours}h`
      colorClass = 'text-red-500'
    } else if (diffDays < 30) {
      timeText = `Il y a ${diffDays} jour${diffDays > 1 ? 's' : ''}`
      colorClass = 'text-red-500'
    } else {
      timeText =
        `Il y a ${diffMonths} mois` +
        (restDays > 0 ? ` ${restDays} jour${restDays > 1 ? 's' : ''}` : '')
      colorClass = 'text-red-500'
    }

    return textOnly ? timeText : <span className={colorClass}>{timeText}</span>
  }